import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import facilityRoutes from '../facility/routes';
import Main from '../layouts/Main';
import EnvironmentBadge from '../layouts/EnvironmentBadge';
import React from 'react';
import RouteErrorPage from './RouteErrorPage';
import Authenticated from '../layouts/Authenticated';
import loginRoutes from '../login/routes';
import inmateRoutes from '../inmate/routes';
import tvRoutes from '../tv/routes';
import textMessageRoutes from '../text-message/routes';
import taxRoutes from '../tax/routes';
import smsVoiceNumberRoutes from '../sms-voice-number/routes';
import stationRoutes from '../station/routes';
import housingUnitRoutes from '../housing-unit/routes';
import saltMinionRoutes from '../salt-minion/routes';
import repairTicketRoutes from '../repair-ticket/routes';
import mobileDeviceRoutes from '../mobile-device/routes';
import mobileDevicePurchaseRoutes from '../mobile-device-purchase/routes';
import invoiceRoutes from '../invoice/routes';
import facilityEquipmentRoutes from '../facility-equipment/routes';
import commissaryTransferRoutes from '../commissary-transfer/routes';
import cdrRoutes from '../cdr/routes';
import shippingTicketRoutes from '../shipping-ticket/routes';
import cardRoutes from '../card/routes';
import configurationRoutes from '../configuration/routes';
import supportRoutes from '../support/routes';
import inmatePostOfficeRoutes from '../inmate-post-office/routes';
import inmateRequestsRoutes from '../inmate-requests/routes';
import personSearchRoutes from '../person-search/routes';
import gameRoutes from '../game/routes';
import musicRoutes from '../music/routes';
import customerRoutes from '../customer/routes';
import creditCardRoutes from '../credit-card/routes';
import inmateAccountPaymentRoutes from '../inmate-account-payment/routes';
import audioVideoInmateAccountPaymentRoutes from '../audio-video-inmate-account-payment/routes';
import facilityUserRoutes from '../facility-user/routes';
import staffUserRoutes from '../staff-user/routes';
import ratePlanRoutes from '../rate-plan/routes';
import onlineUserRoutes from '../online-user/routes';
import referenceMaterialRoutes from '../reference-material/routes';
import serviceRateRoutes from '../service-rate/routes';
import onlineOrderRoutes from '../online-order/routes';
import translationRoutes from '../translation/routes';
import changelogRoutes from '../changelog/routes';
import logoutRoutes from '../logout/routes';
import homeRoutes from '../home/routes';
import accountRoutes from '../account/routes';
import apiLogRoutes from '../api-log/routes';
import apiRoleRoutes from '../api-role/routes';
import acknowledgementRoutes from '../acknowledgement/routes';
import callRoutes from '../call/routes';

export function buildAppRoutes(): RouteObject[] {
  return [
    ...loginRoutes,
    {
      path: '/',
      element: <Main />,
      errorElement: (
        <Authenticated navbarBrandAddon={<EnvironmentBadge />}>
          <RouteErrorPage
            notFound={{
              title: 'Not found',
              message: 'The requested page could not be found.',
              iconClassName: 'fa-search',
              tone: 'warning',
            }}
            badRequest={{
              title: 'Invalid request',
              message: 'The URL is missing required information, or it is invalid.',
              iconClassName: 'fa-link',
              tone: 'warning',
            }}
            fallback={{
              title: 'Something went wrong',
              message: 'An unexpected error occurred. Please try again.',
              iconClassName: 'fa-exclamation-triangle',
              tone: 'danger',
            }}
          />
        </Authenticated>
      ),
      children: [
        ...homeRoutes,
        ...accountRoutes,
        ...apiLogRoutes,
        ...apiRoleRoutes,
        ...acknowledgementRoutes,
        ...callRoutes,
        ...facilityRoutes,
        ...inmateRoutes,
        ...tvRoutes,
        ...textMessageRoutes,
        ...taxRoutes,
        ...smsVoiceNumberRoutes,
        ...stationRoutes,
        ...housingUnitRoutes,
        ...saltMinionRoutes,
        ...repairTicketRoutes,
        ...mobileDeviceRoutes,
        ...mobileDevicePurchaseRoutes,
        ...invoiceRoutes,
        ...facilityEquipmentRoutes,
        ...commissaryTransferRoutes,
        ...cdrRoutes,
        ...shippingTicketRoutes,
        ...cardRoutes,
        ...configurationRoutes,
        ...supportRoutes,
        ...inmatePostOfficeRoutes,
        ...inmateRequestsRoutes,
        ...personSearchRoutes,
        ...gameRoutes,
        ...musicRoutes,
        ...customerRoutes,
        ...creditCardRoutes,
        ...inmateAccountPaymentRoutes,
        ...audioVideoInmateAccountPaymentRoutes,
        ...facilityUserRoutes,
        ...staffUserRoutes,
        ...ratePlanRoutes,
        ...onlineUserRoutes,
        ...referenceMaterialRoutes,
        ...serviceRateRoutes,
        ...onlineOrderRoutes,
        ...translationRoutes,
        ...changelogRoutes,
        ...logoutRoutes,
      ],
      handle: { crumb: () => ({ label: 'Home', to: '/' }) },
    },
  ];
}

export function createAppRouter() {
  return createBrowserRouter(buildAppRoutes());
}
